(function ($) {
    $.fn.itemPicker = function (options) {
        var opts = $.extend({}, $.fn.itemPicker.defaults, options);

        return this.each(function () {
            var comboBox;
            var originalTemplate = kendo.template('<div style="padding: 10px; margin-top: 10px; text-align: center; border-top:2px solid \\#aaa;"><span class="extendedTemplateText">' + opts.extendedQueryOptions.originalText + '</span><button class="btn btn-info" data-bind="click: toggleDataSource">' + opts.extendedQueryOptions.originalButtonText + '</button></div>');
            var extendedTemplate = kendo.template('<div style="padding: 10px; margin-top: 10px; text-align: center; border-top:2px solid \\#aaa;"><span class="extendedTemplateText">' + opts.extendedQueryOptions.alternateText + '</span><button class="btn btn-info" data-bind="click: toggleDataSource">' + opts.extendedQueryOptions.alternateButtonText + '</button></div>');

            //Configure DataSources
            var originalDataSourceOptions = {
                transport: {
                    read: {
                        dataType: "json",
                        type: opts.queryOptions.type,
                        url: opts.queryOptions.dataSource.url
                    }
                },
                schema: {
                    data: "Data",
                    total: "Total",
                    model: opts.schemaModel
                },
                sort: [{ field: "Text", dir: "asc" }],
                pageSize: opts.virtualizeOptions.dataSource.pageSize,
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true
            }

            var extendedDataSourceOptions = {
                transport: {
                    read: {
                        dataType: "json",
                        type: opts.extendedQueryOptions.type,
                        url: opts.extendedQueryOptions.dataSource.url
                    }
                },
                schema: {
                    data: "Data",
                    total: "Total",
                    model: opts.schemaModel
                },
                sort: [{ field: "Text", dir: "asc" }],
                pageSize: opts.virtualizeOptions.dataSource.pageSize,
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true
            }

            //Additional DataSource Options
            if (opts.usingMvcForAjax) {
                originalDataSourceOptions.type = "aspnetmvc-ajax";
                extendedDataSourceOptions.type = "aspnetmvc-ajax";
            }  

            //ViewModel containing dataSources and dataSource switching logic. Makes for easy click events
            var dataSourcesViewModel = kendo.observable({
                originalDataSource: new kendo.data.DataSource(originalDataSourceOptions),
                extendedDataSource: new kendo.data.DataSource(extendedDataSourceOptions),
                extendedSearch: false,
                toggleDataSource: function () {
                    var originalDataSource = this.get("originalDataSource"),
                        extendedDataSource = this.get("extendedDataSource");


                    if (this.get("extendedSearch")) {
                        originalDataSource.filter(extendedDataSource.filter());

                        comboBox.setDataSource(originalDataSource);
                        comboBox.setOptions({ footerTemplate: originalTemplate });

                        this.set("extendedSearch", false);
                    } else {
                        extendedDataSource.filter(originalDataSource.filter());

                        comboBox.setDataSource(extendedDataSource);
                        comboBox.setOptions({ footerTemplate: extendedTemplate });

                        this.set("extendedSearch", true);
                    }
                },
                returnToOriginalDataSource: function () {
                    if (this.get("extendedSearch")) {
                        comboBox.setDataSource(this.get("originalDataSource"));
                        comboBox.setOptions({ footerTemplate: originalTemplate });

                        this.set("extendedSearch", false);
                    }
                }
            });

            //Configure ComboBox
            var comboBoxOptions = {
                dataTextField: "Text",
                dataValueField: "Id",
                filter: opts.filter,
                template: opts.displayTemplate,
                placeholder: opts.placeHolder,
                dataBound: opts.dataBound,
                select: opts.select,
                height: opts.dropdownHeight,
                minLength: opts.minLength,
                enforceMinLength: true,
                dataSource: dataSourcesViewModel.get("originalDataSource"),
                virtual: false,
                dataBound: function (e) {
                    kendo.bind(e.sender.list, dataSourcesViewModel);

                    opts.dataBound.call(this, e);
                },
                filtering: function (e) {
                    if (e.filter.value.length < opts.minLength) {
                        e.sender.close()
                        dataSourcesViewModel.returnToOriginalDataSource();
                        e.preventDefault();
                    }
                },
                select: function (e) {
                    opts.select.call(this, e);
                }
            }

            //Additional ComboBox Options
            if (opts.hideDropdown) {
                comboBoxOptions.autoBind = false;
            }

            if (opts.allowExtendedQuery) {
                comboBoxOptions.footerTemplate = originalTemplate;
            }

            if (opts.virtualizeResults) {
                comboBoxOptions.virtual = {
                    itemHeight: opts.virtualizeOptions.itemHeight,
                    valueMapper: function (options) {
                        $.ajax({
                            url: opts.virtualizeOptions.dataSource.url,
                            type: opts.virtualizeOptions.dataSource.type,
                            dataType: "json",
                            data: convertValues(options.value),
                            success: function (data) {
                                options.success(data);
                            }
                        })
                    }
                }
            }

            //Initialize ComboBox
            comboBox = $(this).kendoComboBox(comboBoxOptions).data("kendoComboBox");

            //The widget is the highest level element Kendo creates around our initial element.
            //All other elements can be found under this one.
            var widget = $(this).closest('.k-widget.k-combobox');    

            //Additional option that must come after initialization
            if (opts.hideDropdown) {
                var select = widget.find(".k-select");
                var wrapper = widget.find(".k-dropdown-wrap");
                var input = widget.find('.k-input');
                var clearButton = widget.find('.k-clear-value');

                select.hide();
                wrapper.css("padding-right", "0");
                input.css("padding-right", "0");
                clearButton.css("right", "1em");
            }

            //minLength enforcement
            widget.keydown(function () {
                if (comboBox.text().length < opts.minLength) {
                    comboBox.close();
                }
            });
            widget.keyup(function () {
                if (comboBox.text().length < opts.minLength) {
                    comboBox.close();
                }
            });
        });

        //required method for virtualization
        function convertValues(value) {
            var data = {};

            value = $.isArray(value) ? value : [value];

            for (var idx = 0; idx < value.length; idx++) {
                data["values[" + idx + "]"] = value[idx];
            }

            return data;
        }
    };

    $.fn.itemPicker.defaults = {
        hideDropdown: false,
        allowExtendedQuery: false,
        virtualizeResults: false,
        usingMvcForAjax: false,
        virtualizeOptions: {
            itemHeight: 104,
            dataSource: {
                url: "",
                type: "POST",
                pageSize: 80
            }
        },
        queryOptions: {
            dataSource: {
                type: "POST",
                url: ""
            }
        },
        extendedQueryOptions: {
            dataSource: {
                type: "POST",
                url: ""
            },
            originalText: "Can't find it? Try...",
            originalButtonText: "Full Campus Search",
            alternateText: "Return to...",
            alternateButtonText: "Local Search"
        },
        schemaModel: {
            fields: {
                Id: { field: "Id", type: "string" },
                Text: { field: "Text", type: "string" }
            }
        },
        placeHolder: "Select an Item...",
        displayTemplate: '<span class="k-state-default"><h3>#:Text#</h3><p>#:Id#</p></span>',
        dropdownHeight: 400,
        filter: "contains",
        minLength: 3,
        dataBound: function () { },
        select: function () { }
    };
}(jQuery));